import { useOrder } from '@olo-web/domain/orders/queries/useOrder';

export const useHasStartedTab = () => {
  const { data: order } = useOrder();

  return order?.paymentAuth ? true : false;
};
